import trackRuneChanges from '../helpers/trackRuneChanges'
import loadTraits from '../helpers/loadTraits.js'
//---------------------
// process delete rune
//---------------------
export default function processDeleteRune({
  rune,
  character,
  changed_runes = [],
  original_runes = [],
}) {
  console.log('--------------------------------')
  console.log('IN processDeleteRune rune = ', rune)
  //-----------------------------------------
  // build new array excluding deletion rune
  //-----------------------------------------
  const newRunes = character.runes.filter((s) => s.id !== rune.id)
  //------------------
  // assign new array
  //------------------
  character.runes = newRunes
 //------------------------------------
   // update traits where rune has trait
   //------------------------------------
   console.log('DX.1 rune = ', rune.name, ' has trait = ', rune.trait)
   if (rune.trait) {
     console.log('DX.2 off to reloadTraits to remove rune trait')
     character = loadTraits({ character })
   }
  //---------------------------------
  // track changes (record deletion)
  //---------------------------------
  const updated_changed_runes = trackRuneChanges({
    rune,
    original_runes: original_runes,
    changed_runes: changed_runes,
    delete: true, // used to remove entry from changed_runes where is new local rune (not written to db yet)
  })
  console.log('updated_changed_runes after deletion:', updated_changed_runes)
  //---------
  // returns
  //---------
  return { character, updated_changed_runes }
}
